import './styles/graphic.scss';

import mapboxgl from 'mapbox-gl';
// import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'; // uncomment for geocoder
// import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'; // this too
import 'whatwg-fetch';

let isInit = false;

const useRollovers = true;


// const STYLE_URL = 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx';
const STYLE_URL = 'mapbox://styles/cnndigital/clily7wf5015q01p7avk03r9t';

const CIRCLE_LAYER_NAME = 'circle-id';

const drawMap = (container, isMobile) => {
  if (isInit) return;
  mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

  // screen size config
  const optionsSm = {
    initZoom: 2.1,
    minZoom: 2.1,
    maxZoom: 6,
    center: [-95.5, 38.5],
  };

  const optionsLg = {
    initZoom: 3.2,
    minZoom: 3,
    maxZoom: 6,
    center: [-97, 38.5],
  };


  // These colors need to match the vars in graphic.scss
  const colorRamp = {
    property: 'category',
    stops: [
      [1, '#53A796'],
      [2, '#F8C153'],
      [3, '#F18851'],
      [4, '#C56322'],
      [5, '#C52622'],
      [6, '#732600'],
    ],
  };

  const options = (isMobile) ? optionsSm : optionsLg;

  const map = new mapboxgl.Map({
    container: 'map',
    style: STYLE_URL,
    center: options.center,
    zoom: options.initZoom,
    maxZoom: options.maxZoom,
    minZoom: options.minZoom,
  });

  // disable map rotation using right click + drag
  map.dragRotate.disable();

  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();

  // zoom controls without the compass
  const nav = new mapboxgl.NavigationControl(
    {
      showCompass: false,
    },
  );
  map.addControl(nav, 'top-right');


  const byAQIDesc = (a, b) => a.aqi - b.aqi;

  const buildFeatures = data => data.map(
    d => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [d.longitude, d.latitude],
      },
      properties: { ...d },
    }),
  );


  const drawMapData = (data) => {
    const geojson = {
      type: 'FeatureCollection',
      features: buildFeatures(data.sort(byAQIDesc)),
    };

    // console.log('geojson', geojson);

    // debug: examine layers - uncomment below and check the layer names in console
    // const { layers } = map.getStyle();
    // console.log('layers', layers);
    const TARGET_LAYER = 'state-label';

    map.addLayer(
      {
        id: CIRCLE_LAYER_NAME,
        type: 'circle',
        source: {
          type: 'geojson',
          data: geojson,
        },

        paint: {
          'circle-radius': 4,
          'circle-opacity': 1,
          'circle-color': colorRamp,
          'circle-stroke-color': '#000',
          'circle-stroke-width': 0.25,
        },
      },
      TARGET_LAYER,
    );
  };

  // wait for the style to load then do all the other setup
  map.on('load', () => {
    fetch(`https://ix.cnn.io/data/aqi-airnow-gov/processed.json?t=${Math.random()}`)
      .then(response => response.json()).then(drawMapData)
      .catch((ex) => {
        console.log('parsing failed', ex);
      });


    // Create a popup, but don't add it to the map yet.
    const popup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: false,
    });


    const getPopupTemplate = (features) => {
      // console.log(features);
      // we don't have any name associated with it, so just blanking out but leaving in case we get it
      const header = (false) ? `<p class="popup-loc">${'NAME'}</p>` : '';
      const body = `<p class="popup-aqi-level aqi-${features.category}">Air Quality Index: <strong>${features.aqi}</strong></p>`;
      return `${header}${body}`;
    };

    // base popup function to use with the search or the rollover popup
    const showPopupBase = p => (coordinates, features) => {
      // console.log(features);
      const description = getPopupTemplate(features);
      // Populate the popup and set its coordinates
      p.setLngLat(coordinates).setHTML(description).addTo(map);
    };


    if (useRollovers) {
      const popupHover = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      });

      const showPopupHover = showPopupBase(popupHover);

      map.on('mouseenter', CIRCLE_LAYER_NAME, (e) => {
        // Change the cursor style as a UI indicator.
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mousemove', CIRCLE_LAYER_NAME, (e) => {
        const coordinates = e.lngLat;
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        if (!e.features || !e.features[0].properties) return null;
        showPopupHover(coordinates, e.features[0].properties);
      });

      map.on('mouseleave', CIRCLE_LAYER_NAME, () => {
        map.getCanvas().style.cursor = 'auto';
        popupHover.remove();
      });
    }
  });


  isInit = true;
};

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  drawMap(container, isMobile);
}
